import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "onClick", "type", "style"];
import React from 'react';
import classNames from 'classnames/bind';
import styles from './CloseButton.css';
var cx = classNames.bind(styles);

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("button", _extends({
    className: cx('CloseIcon', className) // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    onClick: onClick,
    style: style
  }, rest), children);
};

export default CloseButton;